"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = exports.LoginPageConfig = void 0;
var tslib_1 = require("tslib");
var centered_card_1 = require("../../components/centered.card/centered.card");
var login_1 = require("../../modules/auth/login");
var index_1 = require("../../services/index");
var page_1 = require("../page");
exports.LoginPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.login,
    path: '/login',
    auth: { required: false },
    layout: { nav: false, banner: false }
};
var LoginPage = /** @class */ (function (_super) {
    tslib_1.__extends(LoginPage, _super);
    function LoginPage(redirectURL) {
        var _this = _super.call(this, exports.LoginPageConfig) || this;
        _this.name = 'Login';
        _this.redirectURL = redirectURL || index_1.Services.Route.getRouteURL(page_1.IkePageName.map);
        _this.component = new login_1.SSOLoginComponent();
        _this.reaction(function () { return index_1.Services.User.current; }, function (user) { return _this.checkLoggedIn(user); }, { fireImmediately: true });
        return _this;
    }
    Object.defineProperty(LoginPage.prototype, "nodes", {
        get: function () {
            return centered_card_1.CenteredCard.view(this.component.view());
        },
        enumerable: false,
        configurable: true
    });
    LoginPage.prototype.enterSite = function () {
        index_1.Services.Route.goRaw(this.redirectURL);
    };
    LoginPage.prototype.checkLoggedIn = function (user) {
        if (user != null) {
            this.enterSite();
        }
    };
    return LoginPage;
}(page_1.IkePage));
exports.LoginPage = LoginPage;
//# sourceMappingURL=login.page.js.map